import { render, staticRenderFns } from "./FormPrivilege.vue?vue&type=template&id=2a65d98b&scoped=true&"
import script from "./FormPrivilege.vue?vue&type=script&lang=js&"
export * from "./FormPrivilege.vue?vue&type=script&lang=js&"
import style0 from "./FormPrivilege.vue?vue&type=style&index=0&id=2a65d98b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a65d98b",
  null
  
)

export default component.exports